import { faClipboardList, faDogLeashed } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from 'components/Tasks/Detail/EmptyState/TaskDetailEmptyState.module.scss';
import Button from 'components/UI/V3/Button/Button';
import React from 'react';

interface TaskDetailEmptyStateProps {
    onAddTask: () => void;
    readOnly?: boolean;
}

export const TaskDetailEmptyState: React.FC<TaskDetailEmptyStateProps> = ({ onAddTask, readOnly }) => {
    return (
        <div className={styles.root}>
            <div className={styles.icon}>
                <FontAwesomeIcon icon={faClipboardList} />
            </div>

            <h2 className={styles.title}>Tasks</h2>
            <p className={styles.description}>Click the “Add Task” button to add your first one</p>

            <Button
                label="+ Add Task"
                className={styles.addTaskButton}
                disabled={readOnly}
                onClick={onAddTask}
            />
        </div>
    );
};
